import "./location-component.scss";
import m from "mithril";
import tools from "../../../old/tools/tools";
import "./location-component.scss";
import {Icons, Portal} from "../../../old/tools/constructui";
import button from "../button/index";

export default () => {
	let showPortal = false;
	let notPrecise = false;
	let permissionDenied = false;
	let gettingLocation = false;
	let needPermission = false;
	let currentLocation = {};
	let finalLocation = undefined;
	let _timeout = 30000;
	let _precision = 500;

	const readLocation = (
		setLocation, //: (location: ILocation) => void,
		setError //: (errorMessage: string) => void,
		// setAccuracy//: (acc: number) => void
	) => {
		if (navigator.geolocation) {
			const geoId = navigator.geolocation.watchPosition(
				(position) => {
					// console.log("got location", {position});
					// const lat = position.coords.latitude;
					// const lng = position.coords.longitude;
					setLocation && setLocation(GetPrasoraLocation(position));
					// setAccuracy && setAccuracy(position.coords.accuracy);
					// console.log({ lat, lng, position }, position.coords.accuracy);
					// if (position.coords.accuracy > 10) {
					//     //showErrorSnackBar
					//     console.log({ error: "The GPS accuracy isn't good enough" });
					//     setError && setError("The GPS accuracy isn't good enough");
					// }
				},
				(e) => {
					// showErrorSnackBar(e.message);
					console.log({error: e.message});
					setError && setError(e.message);
				},
				{enableHighAccuracy: true, maximumAge: 0, timeout: 30000}
			);
			return () => {
				console.log("Clear watch called");
				window.navigator.geolocation.clearWatch(geoId);
			};
		}

		return;
	};

	// async function HasGeolocationPermission() {
	//     return new Promise(resolve => {
	//         navigator.permissions &&
	//             navigator.permissions.query({ name: 'geolocation' }).then(function (PermissionStatus) {
	//                 if ('granted' === PermissionStatus.state) {
	//                     // navigator.geolocation.getCurrentPosition(function(geoposition) {
	//                     //     console.log(geoposition) /* You can use this position without prompting the user if the permission had already been granted */
	//                     // })
	//                     resolve(true);
	//                 }
	//                 else
	//                     resolve(false);
	//             })
	//     })
	// }

	function AnimationMessage(animation, message, ...buttons) {
		return m(".animation-message", animation, m("span", message), ...buttons);
	}

	function GettingLocation() {
		return AnimationMessage(m(".portal-getting-location"), `Getting Location`);
	}
	function ShowErrorMessage(message) {
		return AnimationMessage(
			m(
				".portal-error",
				m("svg", {width: "64px", height: "48px"}, [
					m("polyline", {points: "0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24", id: "back"}),
					m("polyline", {points: "0.157 23.954, 14 23.954, 21.843 48, 43 0, 50 24, 64 24", id: "front"}),
				])
			),
			message,
			m(button, {
				label: "Oh! OK!",
				onclick: () => {
					showPortal = false;
				},
			})
		);
	}

	function RequestPermission(OnUpdate) {
		ReadLocation().then((location) => {
			ReceivedLocationUpdateOnBackend(OnUpdate, location);
		});
	}

	function ReceivedLocationUpdateOnBackend(OnUpdate, location) {
		// _currentPrecision = undefined;
		// console.log("received location after Requesting Permission", { location });
		if (location && location.accuracy <= _precision) {
			// console.log("DONE", location);
			// value = location;
			finalLocation = location;
			showPortal = false;
			if (OnUpdate) OnUpdate(location);
		}

		if (!location || location.accuracy >= _precision) {
			notPrecise = true;
			gettingLocation = false;
		}
		m.redraw();
	}
	function Waiting() {
		return AnimationMessage(m(".portal-waiting"), "Checking");
	}

	async function ReadLocation() {
		// trial++;
		return new Promise((resolve) => {
			let readLocationOperation = readLocation(
				(position) => {
					// console.log({ position });
					if (currentLocation.accuracy && currentLocation.accuracy > position.accuracy) {
						currentLocation.index = (currentLocation.index || 0) + 1;
						return;
					}
					currentLocation = {...position, index: (currentLocation.index || 0) + 1};

					if (currentLocation.accuracy && currentLocation.accuracy <= _precision) {
						// console.log("accuracy is fine. resolvng", { currentLocation, readLocationOperation });
						if (readLocationOperation) {
							readLocationOperation();
							readLocationOperation = undefined;
							resolve(currentLocation);
						}
					}

					m.redraw();
				},
				(err) => {
					// error = err;
					// debugmessage = `error: ${err}`;
					// console.log({error});
				}
			);

			tools.Wait(_timeout).then(() => {
				// console.log("Timed Out", { currentLocation });
				if (readLocationOperation) {
					readLocationOperation();
					readLocationOperation = undefined;
					resolve();
				}
			});
		});
	}

	function CheckForPermission(OnUpdate) {
		gettingLocation = true;
		// trial = 0;
		ReadLocation().then((location) => {
			// debugmessage = "received location";
			// console.log("received location", {location});
			ReceivedLocationUpdateOnBackend(OnUpdate, location);
		});
	}

	return {
		oninit: ({attrs: {timeout = 30000, precision = 500, value}}) => {
			_timeout = timeout;
			_precision = precision;
			if (value) finalLocation = JSON.parse(value);

			// console.log({finalLocation});
		},
		view: ({attrs: {editable, locationtype, value, OnUpdate}}) => {
			// console.log({currentURL: finalLocation?.url}); //
			return m(
				".location-field-wrapper",
				finalLocation
					? m(button, {
							small: true,
							basic: true,
							label: editable ? "Location Saved. Open in Map" : "",
							iconLeft: Icons.LINK,
							href: finalLocation?.url,
							target: "_blank",
					  })
					: editable
					? m(
							button,
							{
								small: true,
								label: "Get Location",
								iconLeft: Icons.MAP_PIN,
								onclick: () => {
									showPortal = true;
									CheckForPermission(OnUpdate);
								},
							},
							"Click to Update Location"
					  )
					: undefined,
				showPortal &&
					m(
						Portal,
						{
							style: `position: absolute;
                    top: var(--prasora-header-height);
                    left: 0;`,
						},
						m(
							".portal-outer-layer",
							{
								onclick: () => {
									if (permissionDenied) showPortal = false;
								},
							},
							m(".portal-inner-layer", [
								gettingLocation
									? GettingLocation()
									: permissionDenied
									? ShowErrorMessage("Permission Denied. Please provide permission from Chrome/Safari Settings.")
									: needPermission
									? RequestPermission(OnUpdate)
									: notPrecise
									? ShowErrorMessage(`No GPS. Please check your GPS Settings.`)
									: Waiting(),
							])
						)
					)
			);
		},
	};
};

function GetGoogleURL(lat, lng) {
	function toDegreesMinutesAndSeconds(coordinate) {
		var absolute = Math.abs(coordinate);
		var degrees = Math.floor(absolute);
		var minutesNotTruncated = (absolute - degrees) * 60;
		var minutes = Math.floor(minutesNotTruncated);
		var seconds = Math.floor((minutesNotTruncated - minutes) * 60);

		return degrees + "%C2%B0" + minutes + "'" + seconds + "%22";
	}

	var latitude = toDegreesMinutesAndSeconds(lat);
	var latitudeCardinal = lat >= 0 ? "N" : "S";

	var longitude = toDegreesMinutesAndSeconds(lng);
	var longitudeCardinal = lng >= 0 ? "E" : "W";

	return `https://www.google.com/maps/place/${latitude}${latitudeCardinal}+${longitude}${longitudeCardinal}/@${lat},${lng},18z`;

	//    return latitude + " " + latitudeCardinal + "\n" + longitude + " " + longitudeCardinal;
}

export function GetPrasoraLocation(position) {
	return {
		latitude: position.coords.latitude,
		longitude: position.coords.longitude,
		accuracy: position.coords.accuracy,
		timestamp: position.timestamp,
		altitude: position.coords.altitude,
		altaccuracy: position.coords.altitudeAccuracy,
		url: GetGoogleURL(position.coords.latitude, position.coords.longitude),
	};
}
